import { buildPublicSourceStatusMessage } from "../../../utils/weatherFreshnessCopy";

const WeatherFreshnessText = ({
  healthStatus,
  observedAt,
  error,
  warning,
  fallbackActive,
  backupSourceLabel,
  cached,
  className = "",
}) => {
  const status = buildPublicSourceStatusMessage({
    healthStatus,
    observedAt,
    error,
    warning,
    fallbackActive,
    backupSourceLabel,
    cached,
  });

  return (
    <p
      className={`weather-freshness-text weather-freshness-text--${status.tone} ${className}`.trim()}
      role="status"
    >
      <span className="weather-freshness-text__label">{status.label}</span>
      {status.message && status.message !== status.label ? (
        <span className="weather-freshness-text__message"> — {status.message}</span>
      ) : null}
      {status.detail ? (
        <span className="weather-freshness-text__detail muted"> {status.detail}</span>
      ) : null}
    </p>
  );
};

export default WeatherFreshnessText;
